import React from 'react';

import { MarkdownExtXContent as Markdown } from '../../markdown/markdown';

import './showcase-lesson-teaser-card__description.scss';

interface Props {
    text?: string;
}

export const ShowcaseLessonTeaserCardDescription = ({ text }: Props) => {
    if (!text) {
        return null;
    }

    return <Markdown mix="showcase-lesson-teaser-card__description">{text}</Markdown>;
};
